module.exports = __webpack_public_path__ + "img/chat.0eacf063.png";